module.exports = __webpack_public_path__ + "img/certi-ecler.fa499fb9.png";